import { datadogRum } from '@datadog/browser-rum';

import { ENABLE_DATADOG_RUM } from 'src/config';

import type { ConfigStateContext } from '../hooks/useConfig';

export const setupDatadogRum = (
  environment: string,
  config: ConfigStateContext,
): typeof datadogRum => {
  datadogRum.init({
    applicationId: '24dc7847-2a0e-4e36-8b7c-c2b1558d8b7b',
    clientToken: 'pubd5e9c3393551771a8e868655ba81b96b',
    site: 'datadoghq.com',
    service: 'wpt-cms-unification',
    version: '1.0.0',
    env: environment,
    sessionSampleRate: ENABLE_DATADOG_RUM ? 20 : 0,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.setGlobalContext(config);

  return datadogRum;
};
